var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.getAriaText(_vm.params)))]),_c('c-sector-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"sectorId":_vm.sectorId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }